import { PageController } from '@client/components/_core/layout/PageController';
import { VCurrencyInput } from '@client/components/_shared/forms/view-form/VCurrencyInput';
import { VReadOnly } from '@client/components/_shared/forms/view-form/VReadOnly';
import { VTextArea } from '@client/components/_shared/forms/view-form/VTextArea';
import { VCostCodeSelect } from '@client/components/claims/financials/VCostCodeSelect';
import { VTransactionTypeSelect } from '@client/components/claims/financials/VTransactionTypeSelect';
import { useFormatter } from '@client/hooks/utils/useFormatter';
import { buildCurrencyInputRules } from '@client/utils';
import { getIncreasingAdjustment } from '@shared/utils/business/claim';
import { createFileRoute } from '@tanstack/react-router';
import { Col, Row } from 'antd';
import { Decimal } from 'decimal.js';
import { claimFormStore, useHasClaimWriteAccess } from '../../../store';
import { excessFormStore } from './store';

export const Route = createFileRoute('/console/$orgId/claims/details/$id/financials/excesses/details/$excessId/manage')(
    {
        component: RouteComponent,
    },
);

function RouteComponent() {
    return (
        <PageController route={Route}>
            <ExcessDetailsManage />
        </PageController>
    );
}

function ExcessDetailsManage() {
    const claim = claimFormStore.use.formData();
    const excess = excessFormStore.use.formData();
    const { formatCurrency } = useFormatter();
    // CUR-2675: someone who may read the claim but not edit it changes none of the excess.
    const canWriteClaim = useHasClaimWriteAccess();

    return (
        <Row gutter={[16, 16]} className="mb-4 w-2/3">
            <Col span={12}>
                <VTransactionTypeSelect
                    formStore={excessFormStore}
                    isReadOnly={excess?.isReadOnly || !canWriteClaim}
                    rules={[{ required: true }]}
                    transactionNature="EXCESS"
                    productTypeId={claim?.productTypeId}
                />
            </Col>
            <Col span={12}>
                <VCostCodeSelect
                    formStore={excessFormStore}
                    isReadOnly={excess?.isReadOnly || !canWriteClaim}
                    rules={[{ required: true }]}
                    productTypeId={claim?.productTypeId}
                />
            </Col>
            <Col span={12}>
                <VCurrencyInput
                    label="Excess amount"
                    field="amount"
                    formStore={excessFormStore}
                    isReadOnly={excess?.isReadOnly || !canWriteClaim}
                    rules={buildCurrencyInputRules({ isRequired: true, gtZero: true })}
                />
            </Col>
            <Col span={12}>
                <VReadOnly
                    label="Increasing adjustment"
                    formStore={excessFormStore}
                    formatValueFn={() => formatCurrency(getIncreasingAdjustment(excess?.amount || new Decimal(0)))}
                />
            </Col>
            <Col span={24}>
                <VTextArea
                    label="Description"
                    field="description"
                    formStore={excessFormStore}
                    isReadOnly={excess?.isReadOnly || !canWriteClaim}
                    rules={[{ required: true }]}
                />
            </Col>
        </Row>
    );
}
